import { UserState } from "./types";
import { DetailedLoadStatus } from "../../../../../../common/utils/async-status";

export function getUserInfoLoadStatus(state) {
  return state.user.status.statusType;
}

export function isUserLoggedOut(state) {
  return (
    state.user.status.statusType === DetailedLoadStatus.ERROR &&
    state.user.status.code === 401
  );
}

export function getUserInfo(state: UserState) {
  return state.user.data;
}

export function getLabEnabledStatuses(state) {
  return state.user.data.labs;
}

export function getFormattedCreatedAtDate(state) {
  return new Date(state.user.data.createdAt);
}

export function getUserVstLocale(state) {
  return state.user.data.locale;
}

export function getIsReferenceUser(state) {
  return state.user.data.ssoOnly;
}

export function getFullName(state) {
  return [state.user.data.firstName, state.user.data.lastName].join(" ").trim();
}

export function getReferenceId(state) {
  return state.user.data.ssoOnly ? state.user.data.email.split("@")[0] : null;
}
